import FilledButton from "../../../component/FilledButton";

const AlertPop = ({ handleOpenModal, handleDelete }) => {
    return (
        <div className="modal_body">
            <div className="attached_courses-alert delete-pop">
                <h2>Alert!</h2>
                <p className="text_center mt_3">You are trying to delete an Application.</p>
                <div className="desc">
                    Do you really want to delete this Application?
                </div>
                <div className="action">
                    <FilledButton onClick={() => handleOpenModal()} value="cancel" />
                    <FilledButton onClick={() => handleDelete()} value="yes" className="btn btn_primary" />
                </div>
            </div>
        </div>
    )
};

export default AlertPop;